import {theme} from "antd";

const sharedButtonTokens = {
  colorPrimary: "#e1ad3a",
  primarycolor: "var(--theme-text-on-primary)",
  defaultBg: "transparent",
  defaultHoverBg: "#241a0c",
  defaultcolor: "var(--theme-text-on-primary)",
  defaultActivecolor: "var(--theme-text-on-primary)",
  defaultHovercolor: "var(--theme-text-on-primary)",
  colorPrimaryHover: "#e1ad3a",
};

const sharedMenuTokens = {
  lineHeight: 21,
  fontSize: 18,
  fontWeight: 400,
  iconMarginInlineEnd: 22,
  itemBg: "transparent",
  algorithm: true,
  itemHoverColor: "#e1ad3a",
  itemMarginInline: 15,
  itemHeight: 55,
  itemBorderRadius: 15,
  subMenuItemBorderRadius: 15,
};

export const getDarkAntdTheme = () => ({
  cssVar: true,
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: "#e1ad3a",
    colorBgContainer: "#140d04",
    colorPrimaryBg: "#140d04",
    colorTextHeading: "var(--text-primary)",
    colorText: "var(--text-primary)",
    colorBgElevated: "#1c1309",
  },
  components: {
    Button: sharedButtonTokens,
    Layout: {
      headerBg: "#0f0903",
      siderBg: "#140d04",
      headerHeight: "100px",
      bodyBg: "#1c1309",
      algorithm: true,
    },
    Menu: {
      ...sharedMenuTokens,
      popupBg: "#140d04",
      darkItemBg: "transparent",
      darkSubMenuItemBg: "#140d04",
      darkPopupBg: "#140d04",
      darkItemColor: "var(--text-primary)",
      darkItemSelectedBg: "#1c1309",
      darkItemHoverBg: "#1c1309",
      itemColor: "var(--text-primary)",
      darkItemHoverColor: "#e1ad3a",
      darkItemSelectedColor: "#e1ad3a",
    },
    Content: {algorithm: true},
    Modal: {
      algorithm: true,
      contentBg: "#140d04",
      headerBg: "#140d04",
      titleColor: "var(--text-primary)",
      colorIcon: "#CCCCCC",
      colorIconHover: "var(--text-primary)",
    },
    Form: {labelColor: "var(--text-primary)"},
    Input: {
      colorTextPlaceholder: "var(--text-primary)",
      activeBg: "#1c1309",
    },
    Select: {
      optionActiveBg: "#1c1309",
      selectorBg: "#140d04",
      optionSelectedBg: "#1c1309",
      optionSelectedColor: "#e1ad3a",
      optionActiveColor: "#e1ad3a",
    },
  },
});

export const getLightAntdTheme = () => ({
  cssVar: true,
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: "#e1ad3a",
    colorBgContainer: "#FFFFFF",
    colorPrimaryBg: "#f0f2f5",
    colorTextHeading: "#111827",
    colorText: "#374151",
    colorBgElevated: "#FFFFFF",
    colorBgLayout: "#f0f2f5",
  },
  components: {
    Button: sharedButtonTokens,
    Layout: {
      headerBg: "#FFFFFF",
      siderBg: "#FFFFFF",
      headerHeight: "100px",
      bodyBg: "#f0f2f5",
      algorithm: true,
    },
    Menu: {
      ...sharedMenuTokens,
      popupBg: "#FFFFFF",
      darkItemBg: "transparent",
      darkSubMenuItemBg: "#f0f2f5",
      darkPopupBg: "#f0f2f5",
      darkItemColor: "#374151",
      darkItemSelectedBg: "#eef0f4",
      darkItemHoverBg: "#eef0f4",
      itemColor: "#374151",
      darkItemHoverColor: "#e1ad3a",
      darkItemSelectedColor: "#e1ad3a",
    },
    Content: {algorithm: true},
    Modal: {
      algorithm: true,
      contentBg: "#FFFFFF",
      headerBg: "#FFFFFF",
      titleColor: "#111827",
      colorIcon: "#8a7d66",
      colorIconHover: "#111827",
    },
    Form: {labelColor: "#374151"},
    Input: {
      colorTextPlaceholder: "#c9bfa8",
      activeBg: "#f3f4f6",
    },
    Select: {
      optionActiveBg: "#f3f4f6",
      selectorBg: "#f3f4f6",
      optionSelectedBg: "#eef0f4",
      optionSelectedColor: "#e1ad3a",
      optionActiveColor: "#e1ad3a",
    },
  },
});

export const rygTheme = getDarkAntdTheme();
